import { useContext } from 'react'
import { UseFormReturn } from 'react-hook-form'

import { PageContext } from '@pages/MapCreateOrEdit/MapCreateOrEdit'
import { MapSettingsFormValues } from '@pages/MapCreateOrEdit/types'

type Props = {
  methods: UseFormReturn<MapSettingsFormValues>
}

export const useHandlers = (props: Props) => {
  const { methods } = props

  const { handleCloseMapSettingsDialog, handleUpdateMapSettings } = useContext(PageContext)

  const {
    handleSubmit,
    formState: { isDirty },
  } = methods

  const handleSave = handleSubmit(data => {
    handleUpdateMapSettings(data)
  })

  const handleClose = () => {
    handleCloseMapSettingsDialog(isDirty)
  }

  return {
    handleSave,
    handleClose,
  }
}
